import { ICompoundType } from 'models/CompoundModel';
import { IKlineSelect } from 'types/klines';
import { IModuleRequest } from 'types/module';
import { IPanelIntro } from 'types/panelsIntro';
import { IRefIds } from '../constants/refs';

export const sortPanelsIntroAlphabetically = (a: IPanelIntro, b: IPanelIntro) => (a.title < b.title ? -1 : 1);

export const sortKlinesAlphabetically = (klines: IKlineSelect[]) => klines.sort((a, b) => (a.title < b.title ? -1 : 1));

export const sortCompoundTypesAlphabetically = (a: ICompoundType, b: ICompoundType) => (a.name < b.name ? -1 : 1);

export const encodeModule = (module: IModuleRequest) => {
  let refId = module.refId;
  if (module.courseId !== 0 && refId === IRefIds.vocs) {
    refId = IRefIds.vocsCourse;
  }
  return module.courseId + '-' + refId;
};

export const getKlineNameFromPath = (option: IKlineSelect) => {
  const parts = option.title.split(' -> ');
  return parts[parts.length - 1];
};

export const convertTargetDialectCodeToApi = (code: string) => code + '(t)';
export const convertSourceDialectCodeToApi = (code: string) => code + '(s)';

/**
 * Formats a server timestamp string (UTC) to user's local timezone
 * @param serverTimestamp - Format: "YYYY-MM-DD HH:mm:ss" (UTC timezone from server)
 * @param options - Optional Intl.DateTimeFormatOptions for custom formatting
 * @returns Formatted date string in user's local timezone, or 'N/A' if invalid
 *
 * @example
 * formatServerTimestamp("2025-10-28 12:34:56")
 * // Returns: "10/28/2025, 14:34:56" (if user is in UTC+2)
 */
export const formatServerTimestamp = (
  serverTimestamp: string | null | undefined,
  options?: Intl.DateTimeFormatOptions
): string => {
  // Handle null/undefined
  if (!serverTimestamp) {
    return 'N/A';
  }

  try {
    // Convert "YYYY-MM-DD HH:mm:ss" to ISO format and parse as UTC
    // Replace space with 'T' and append 'Z' to indicate UTC
    const isoString = serverTimestamp.replace(' ', 'T') + 'Z';
    const date = new Date(isoString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', serverTimestamp);
      return serverTimestamp; // Return original string if parsing fails
    }

    // Default formatting options
    const defaultOptions: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    // Format to user's local timezone
    return date.toLocaleString(undefined, options || defaultOptions);
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return serverTimestamp; // Return original on error
  }
};
